import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
 * A component to use inside the modal.
 *
 * title - The title at the top of the component.
 * iconName - The icon to display at the left of the content.
 * content - The description inside the modal item. (slot)
 */
@customElement('nn-modal-list-item')
export class ModalListItem extends LitElement {
  static styles = css`
    .nn-modal-list-item {
      display: flex;
      flex-direction: row;
      font-family: 'font-light';
      gap: var(--nn-modal-list-item_gap, 16px);
    }
    .nn-modal-list-item__content {
      color: var(
        --nn-modal-list-item_nn-modal-list-item__content_color,
        #494949
      );
      display: flex;
      flex-direction: column;
      font-size: var(
        --nn-modal-list-item_nn-modal-list-item__content_font-size,
        16px
      );
      font-weight: 300;
    }
    .nn-modal-list-item__title {
      color: var(--nn-modal-list-item_nn-modal-list-item__title_color, #000);
      font-family: 'font-heavy';
      font-size: var(
        --nn-modal-list-item_nn-modal-list-item__title_font-size,
        20px
      );
      margin: var(--nn-modal-list-item_nn-modal-list-item__title_margin, 0);
      padding-bottom: var(
        --nn-modal-list-item_nn-modal-list-item__title_padding-bottom,
        8px
      );
    }
    .nn-modal-list-item__subtitle {
      color: var(
        --nn-modal-list-item_nn-modal-list-item__subtitle_color,
        #595959
      );
      font-family: 'font-heavy';
      font-size: var(
        --nn-modal-list-item_nn-modal-list-item__subtitle_font-size,
        20px
      );
      margin: var(--nn-modal-list-item_nn-modal-list-item__subtitle_margin, 0);
      padding-bottom: var(
        --nn-modal-list-item_nn-modal-list-item__subtitle_padding-bottom,
        8px
      );
    }
    .nn-modal-list-item__icon {
      margin-top: auto;
      margin-bottom: auto;
    }
  `;

  @property({ type: String }) title = 'Modal Item';

  @property({ type: String }) subtitle = '';

  @property({ type: String }) iconName = '';

  render() {
    return html`
      <li class="nn-modal-list-item">
        <nn-generic-icon
          iconName="${this.iconName}"
          class="nn-modal-list-item__icon"
        ></nn-generic-icon>
        <div class="nn-modal-list-item__content">
          <p class="nn-modal-list-item__title">
            ${this.title}
            <span class="nn-modal-list-item__subtitle">${this.subtitle} </span>
          </p>
          <slot name="content"></slot>
        </div>
      </li>
    `;
  }
}
